import { render, staticRenderFns } from "./NotificationsLink.vue?vue&type=template&id=18584326&scoped=true"
import script from "./NotificationsLink.vue?vue&type=script&lang=js"
export * from "./NotificationsLink.vue?vue&type=script&lang=js"
import style0 from "./NotificationsLink.vue?vue&type=style&index=0&id=18584326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18584326",
  null
  
)

export default component.exports